import { render, staticRenderFns } from "./SchoollevelsList.vue?vue&type=template&id=5f5bc949&scoped=true&"
import script from "./SchoollevelsList.vue?vue&type=script&lang=ts&"
export * from "./SchoollevelsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5bc949",
  null
  
)

export default component.exports